<template lang="html">

<div class="recordList">
  <div class="nowNumber" v-if="recordArr.length > 0">当前版本：{{recordArr[0].recordNum}}</div>
  <el-table
        :data="recordArr"
        border
        style="width: 100%">
        <el-table-column fixed="left" align="center" width="60" label="序号">
            <template slot-scope="scope">
                 {{ scope.$index + (params.no - 1)*params.size + 1 }}
            </template>
        </el-table-column>
        <el-table-column prop="recordNum" align="center" label="历史版本">
            <template slot-scope="scope">
                 <span class="ispan" @click="readRecord(scope.row)">{{ scope.row.recordNum }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="operationUser" align="center" label="审核人" />
   </el-table>

   <div v-if="allPages>1" class="table-footer">

      <el-pagination
        @current-change="pageChange"
        :current-page="params.no"
        :page-size="params.size"
        layout="total, prev, pager, next, jumper"
        :total="params.allEls">
      </el-pagination>

  </div>

  <recordPop ref="recordPop" />

</div>

</template>

<script>
import { getRecord } from '@/api/industryInfos';
import recordPop from './recordPop';
export default {
    components:{
       recordPop
    },
    filters:{
       strTrans(e){
           let arr = ['出售','出租']
           return arr[e-1];
       },
       priceTrans(row,type){
           if(type == 1){
                if(row.isSell){
                   return '-';
                }else{
                   return row.price;
                }
           }else if(type == 2){
                if(row.isSell){
                  return row.price + row.sellingPriceUtil;
                }else{
                  return '-';
                }
           }
       }
    },
    data(){
       return{
           recordArr:[],
           allPages:0,
           loading:false,
           params:{
               industrialSpaceId:'',
               no:1,
               size:5,
               allEls:0
           }
       }
    },
    methods:{
      getList(){
        getRecord(this.params).then(res => {
           this.recordArr = res.industrialSpaceHistoryRecordList;
           this.params.allEls = res.totalElements;
           this.allPages = res.totalPages;
        })
      },
      pageChange(e){
        this.params.no = e;
        this.getList();
      },
      readRecord(row){
        this.$refs.recordPop.popSet(row);
      }
    },
    created(){
      let querys = this.$route.query;
      this.params.industrialSpaceId = querys.id;
      this.getList();
    }
}
</script>

<style lang="scss" scoped>

.recordList{
  .nowNumber{
     color:#409EFF;
     font-size: 14px;
     float: right;
     margin-top: -50px;
  }
  .ispan{
    cursor: pointer;
    color: #409EFF;
  }
  .table-footer{
      margin-top: 20px;
      text-align: right;
  }
}


</style>



// WEBPACK FOOTER //
// recordList.vue?6233cafa